import { render, staticRenderFns } from "./TeamTypesForm.vue?vue&type=template&id=2bb23326&"
import script from "./TeamTypesForm.vue?vue&type=script&lang=js&"
export * from "./TeamTypesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports